
const Home = {
    /*text: 'Home',
    link: '/home',
    icon: 'icon-home'*/
    text: '主页',
    link: '/home',
    icon: 'icon-home'
};

const Categories = {
   /* text: 'Categories',
    link: '/categories/manageCategories',
    icon: 'icon-note'*/
    text: '目录',
    link: '/categories/manageCategories',
    icon: 'icon-note'

};
const Menu = {
    text: '货品',
    link: '/menu/manageItems',
    icon: 'fa fa-th-list'
    /*text: 'Menu Items',
    link: '/menu/manageItems',
    icon: 'fa fa-th-list'*/
};

const Orders = {
    /*text : 'Orders',
    link:'/order/allOrder',
    icon: 'fa fa-bars'*/
    text : '订单',
    link:'/order/allOrder',
    icon: 'fa fa-bars'
};

const Users = {
    text: '顾客',
    link: '/users/manageUsers',
    icon: 'fa fa-users'
    /*text: 'Users',
    link: '/users/manageUsers',
    icon: 'fa fa-users'*/
};

/*const Chat = {
    /*text: 'Chat',
    link:'/chat',
    icon: 'fa fa-comments-o'
    text: '对话',
    link:'/chat',
    icon: 'fa fa-comments-o'
};*/

/*
const Setting = {
    text: '设定',
    link:'/setting',
    icon: 'fa fa-cog'
    /*text: 'Setting',
    link:'/setting',
    icon: 'fa fa-cog'
};*/


/*const Tags = {
    text: 'Tags',
    link: '/tags/all',
    icon: 'fa fa-tags'
};*/

const News = {
    text: '消息',
    link: '/news/manageNews',
    icon: 'fa fa-newspaper-o'
    /*text: 'News',
    link: '/news/manageNews',
    icon: 'fa fa-newspaper-o'*/
};
/*const Business = {
    text: '商号资讯',
    link: '/businessInfo',
    icon: 'fa fa-briefcase'
    /*text: 'Business Info',
    link: '/businessInfo',
    icon: 'fa fa-briefcase'
};*/

/*
const Coupons = {
    text: '优惠券',
    link: '/coupons/all',
    icon: 'fa fa-tags'
    /*text: 'Coupons',
    link: '/coupons/all',
    icon: 'fa fa-tags'
};*/

const pushNotification = {
    text: '发通告',
    link: '/pushNotification',
    icon: 'fa fa-briefcase'    
    /*text: 'Push Notification',
    link: '/pushNotification',
    icon: 'fa fa-briefcase'*/
};

// const Pages = {
//     text: 'Pages',
//     link: '/pages',
//     icon: 'icon-doc',
//     submenu: [
//         {
//             text: 'Login',
//             link: '/login'
//         },
//         {
//             text: 'Register',
//             link: '/register'
//         },
//         {
//             text: 'Recover',
//             link: '/recover'
//         },
//         {
//             text: '404',
//             link: '/404'
//         }
//     ]
// };

// const Ecommerce = {
//     text: 'Ecommerce',
//     link: '/ecommerce',
//     icon: 'icon-basket-loaded',
//     submenu: [
//         {
//             text: 'Orders',
//             lin k: '/ecommerce/orders'
//         },
//         {
//             text: 'Order View',
//             link: '/ecommerce/orderview'
//         },
//         {
//             text: 'Products',
//             link: '/ecommerce/products'
//         },
//         {
//             text: 'Product View',
//             link: '/ecommerce/productview'
//         },
//         {
//             text: 'Checkout',
//             link: '/ecommerce/checkout'
//         }
//     ]
// }




const headingMain = {
    text: 'Navigation',
    heading: true
};

const headingComponents = {
    text: 'Components',
    heading: true
};

const headingMore = {
    text: 'More',
    heading: true
};

export const menu = [
    Home,
    Categories,
    Menu,
    Orders,
    Users,
    //Coupons,
    //Tags,
    pushNotification,
    News,
    //Business,
    //Setting,
    //Chat
    //Pages
];



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/app/routes/menu.ts